import { AlertColor } from '@mui/material';
import RootStore from '@stores/RootStore';
import { action, makeObservable, observable } from 'mobx';
import ToastModel from '../models/ToastModel';

export default class ToastStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            toastModel: observable,
            alert: action,

            onClose: action,
        })
    }

    toastModel: ToastModel = {
        isOpen: false,
        title: "",
        subtitle: null,
        type: 'info',
        autoHideDuration: 2500
    }

    alert = (type: AlertColor, title: string, subTitle?: string | null, autoHideDuration?: number) => {
        if (autoHideDuration === undefined || autoHideDuration === null) {
            switch (type) {
                case 'success':
                    autoHideDuration = 3500;
                    break;
                case "info":
                    autoHideDuration = 3500;
                    break;
                case "warning":
                    autoHideDuration = 5000;
                    break;
                case "error":
                    autoHideDuration = 6500;
                    break;
            }
        }

        this.toastModel = {
            isOpen: true,
            title: title,
            subtitle: subTitle,
            type: type,
            autoHideDuration: autoHideDuration
        }
    }

    onClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        this.toastModel.isOpen = false;
    }
}